import { WebAppProject } from "./project/WebAppProject";

export enum WebAppPlatform
{
  UNKNOWN,
  ANY,
  NONE,
  ANDROID,
  IOS,
  WINDOWS,
  MAC,
  LINUX  
}


export class WebAppPlatforms
{
  static readonly Desktop = [ WebAppPlatform.WINDOWS, WebAppPlatform.MAC, WebAppPlatform.LINUX ];
}